import './footer.css';
import {useTranslation} from "react-i18next";
import React from "react";
import {Link} from "react-router-dom";

const Footer = () => {
    const { i18n } = useTranslation();
    const { t } = useTranslation();

    return (
        <div className="footer">
            <p><Link to="/imprint" dangerouslySetInnerHTML={{__html: t("imprint.link")}} /></p>
            <p dangerouslySetInnerHTML={{__html: t("footer.cookie")}} />
            <hr className="separator" />
            <div className="language">
                {i18n.language === 'de-DE' ? (
                    <button className="button" onClick={() => i18n.changeLanguage('en-EN')}>Switch to English</button>
                ) : (
                    <button className="button" onClick={() => i18n.changeLanguage('de-DE')}>Wechseln zu Deutsch</button>
                )}
            </div>
        </div>
    )
}

export default Footer;